<template>
  <CalculatorReviewAndSignContract v-if="isCalculatorApplicant" />
  <div class="row" v-else>
    <div class="col-12 col-md-4">
      <ProgressSteps :step="step"></ProgressSteps>
    </div>
    <div class="col-12 col-md-8">
      <div class="q-pa-md border-radius-top q-pt-md-none">
        <Review v-if="creditCheckStatus === 'refer' || creditCheckStatus === 'referred'" />
        <Accepted v-if="creditCheckStatus === 'approved' && !enableSignContact" @onSignContract="onSignContract" />
        <!-- <SignContract v-if="enableSignContact && !isWetSignature && !hasPersonalGuarantee" /> -->
        <DigitalSignature v-if="enableSignContact && !isWetSignature && !hasPersonalGuarantee" />
        <Combination v-if="enableSignContact && !isWetSignature && hasPersonalGuarantee" />
        <WetSignature v-if="enableSignContact && isWetSignature" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Review from './Review.vue';
import Accepted from './Accepted.vue';
// import SignContract from './SignContract.vue';
import WetSignature from './WetSignature.vue';
import DigitalSignature from './DigitalSignature.vue';
import Combination from './Combination.vue';
import QueryCreditCheck from './../../graphql/queries/QueryCreditCheck';
import ProgressSteps from '../../components/Molecules/ProgressSteps';
import CalculatorReviewAndSignContract from '@/pages/CalculatorAuth/ReviewAndSignContract/Index';

export default {
  name: 'ReviewAndSignContractIndex',
  data: function () {
    return {
      enableSignContact: false
    };
  },
  components: {
    ProgressSteps,
    Review,
    Accepted,
    WetSignature,
    DigitalSignature,
    Combination,
    CalculatorReviewAndSignContract
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    ...mapGetters({
      isWetSignature: 'vehicleApplication/isWetSignature',
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant',
      isUserSecondaryApplicant: 'vehicleApplication/isUserSecondaryApplicant',
      calculatorApplicant: 'vehicleApplication/isCalculatorApplicant'
    }),

    isCalculatorApplicant() {
      return this.calculatorApplicant;
    },
    creditCheckStatus() {
      if (this.scoreboard && this.scoreboard.statusCreditCheck) return this.scoreboard.statusCreditCheck.toLowerCase();
      else return 'refer';
    },
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    secondaryApplicant() {
      return this.scoreboard?.secondaryApplicant ? this.scoreboard?.secondaryApplicant : null;
    },
    hasPersonalGuarantee() {
      if (
        this.scoreboard &&
        this.scoreboard.businessDetails &&
        this.scoreboard.businessDetails.financeDetails &&
        this.scoreboard.businessDetails.financeDetails.personalGuarantee === 'yes'
      )
        return true;
      else return false;
    },
    step() {
      if (this.isUserPrimaryApplicant) return 4;
      else return 2;
    }
  },
  created() {},
  mounted() {
    if (this.creditCheckStatus === 'waiting') this.$router.push({ name: 'application-on-hold' });
  },
  methods: {
    onSignContract: function () {
      this.enableSignContact = true;
    }
  }
};
</script>
